import script from "./CalendarOverviewPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./CalendarOverviewPage.vue?vue&type=script&lang=ts&setup=true"

import "./CalendarOverviewPage.vue?vue&type=style&index=0&id=11a3a708&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11a3a708"]])

export default __exports__